import { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Detail from './detail'
import { SHAPE_ROOM_DETAIL } from '../shapes'
import { Row } from '@trendmicro/react-grid-system'
import Button from '../../../../Shared/Form/Button'
import './styles.scss'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'

class DetailsUpdater extends PureComponent {

  state = {
    detailValidities: []
  }

  createDetailRow (key, detail, isLastRow) {
    return <Fragment key={key}>
      <Row className={'details-updater-detail-row'}>
        <Detail detail={detail} onChange={(detail, formIsValid) => this.onDetailChange(key, detail, formIsValid)}/>
        <div className={'detail-updater-detail-actions'}>
          {!(key === '0' && isLastRow) &&
            <span className={'details-updater-delete'}><Button
              onClick={() => this.onDeleteClick(key)}>-</Button></span>}
          {isLastRow &&
            <span className={'details-updater-add-more'}><Button onClick={this.onAddMoreClick}>+</Button></span>}
        </div>
      </Row>
      {!isLastRow && <hr/>}
    </Fragment>
  }

  onDetailChange (key, detail, formIsValid) {
    let detailValidities = [...this.state.detailValidities]
    detailValidities[key] = formIsValid
    this.setState({
      detailValidities: detailValidities
    }, () => {
      const details = [...this.props.details]
      details[key] = detail
      this.props.onDetailsChange(details, this._areAllDetailsValid())
    })
  }

  onAddMoreClick = () => {
    activityTrackingService.trackEvent(trackingEvent.addOccupancy)
    const details = [...this.props.details]
    details.push({ label: '', codes: [] })
    this.props.onDetailsChange(details)
  }

  onDeleteClick (key) {
    activityTrackingService.trackEvent(trackingEvent.removeOccupancy)
    const details = [...this.props.details]
    details.splice(key, 1)
    let detailValidities = [...this.state.detailValidities]
    detailValidities.splice(key, 1)
    this.setState({
      detailValidities: detailValidities
    })
    this.props.onDetailsChange(details, this._areAllDetailsValid())
  }

  render () {
    let details = this.props.details
    if (!Array.isArray(details) || details.length === 0) {
      details = [{ label: '', codes: [] }]
    }
    details = Object.entries(details)
    const lastIndex = (details.length - 1).toString()
    return (
      <div className={'details-updater'}>
        {details.map(([key, value]) => this.createDetailRow(key, value, key === lastIndex))}
      </div>
    )
  }

  _areAllDetailsValid () {
    return this.state.detailValidities.indexOf(false) === -1
  }
}

DetailsUpdater.defaultProps = {
  details: []
}
DetailsUpdater.propTypes = {
  details: PropTypes.arrayOf(SHAPE_ROOM_DETAIL),
  onDetailsChange: PropTypes.func.isRequired,
}

export default withTranslation()(DetailsUpdater)
